import { Pipe, PipeTransform } from '@angular/core';
import { getIdAddress } from '../../core';

@Pipe({
    standalone: false,
  name: 'destination',
})
export class DispatchDestinationPipe implements PipeTransform {
  transform(value: any): any {
    if (value) {
        if (value.deliveryMode === 'STORE_WITHDRAWAL') {
          return { type: 'STORE_WITHDRAWAL', destination: value };
        } else {
          const address = getIdAddress(value);
          return { type: 'HOME_DELIVERY', destination: address };
        }
      } else {
        return { type: 'HOME_DELIVERY', destination: '' };
      }
  }
}
